import './SubjectTeachers.css';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from 'react-router';
import { BsPlusCircleFill } from "react-icons/bs";
import { fetchSubjectTeachers, setCurrentPage } from "../../redux/slices/subjectTeachersSlice";
import { getStudentSubjects } from "../../redux/slices/subjectsSlice";

function SubjectTeachers() {
  const { isDarkMode } = useDarkMode();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subjectId } = useParams();
  const { teachers, loading, error, pagination, currentPage } = useSelector((state) => state.subjectTeachers);
  const { studentSubjects, subjectsLoading } = useSelector((state) => state.subjects);
  
  const [subjectName, setSubjectName] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check if user is authenticated
  const isAuthenticated = !!localStorage.getItem("token3almny");

  useEffect(() => {
    if (isAuthenticated && subjectId) {
      dispatch(fetchSubjectTeachers({ subjectId, page: 1 }));
    }
  }, [dispatch, subjectId, isAuthenticated]);

  // Get subject name from studentSubjects
  useEffect(() => {
    if (studentSubjects.length > 0 && subjectId) {
      const subject = studentSubjects.find(sub => sub.id == subjectId);
      if (subject) {
        setSubjectName(subject.title);
      }
    }
  }, [studentSubjects, subjectId]);

  // Handle page change
  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
    if (isAuthenticated && subjectId) {
      dispatch(fetchSubjectTeachers({ subjectId, page }));
    }
  };

  // Static teachers data for guest mode
  const staticTeachers = [
    {
      id: 1,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      id: 2,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/34.jpg",
    },
    {
      id: 3,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/36.jpg",
    },
    {
      id: 4,
      name: "اسم المدرس",
      subject: "علوم",
      lessons: 32,
      students: "+50",
      image: "https://randomuser.me/api/portraits/men/34.jpg",
    },
  ];

  // Get teachers to display
  const teachersToDisplay = isAuthenticated ? teachers : staticTeachers;

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  return (
    <div className={`all-lessons-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="container">
        {/* Breadcrumb */}
        <div className="lessons-breadcrumb">
          <h1 className="breadcrumb-title">مدرسين {subjectName}</h1>
          <div className="breadcrumb-links2">
            <span className="breadcrumb-link">الرئيسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-link">المواد الدراسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">{subjectName}</span>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">جاري التحميل...</span>
            </div>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="text-center my-4">
            <div className="error-message">
              <p>حدث خطأ في تحميل بيانات المدرسين</p>
              <p>{error}</p>
            </div>
          </div>
        )}

        {/* Teachers Grid */}
        <div className="teachers-grid">
          {teachersToDisplay.length > 0 ? (
            teachersToDisplay.map((teacher, index) => (
              <Link to={`/teacherDetails/${teacher.id || index}`} className="text-decoration-none" key={teacher.id || index}>
                {teachersToDisplay?.length === 1 ? (
                  <div className="teacher-card" style={{width : "200px" , margin : '0 auto'}}>
                    <div className="teacher-image">
                      <img 
                        src={teacher.prof_img || teacher.image || "https://randomuser.me/api/portraits/men/32.jpg"} 
                        alt={teacher.name} 
                        onError={(e) => {
                          e.target.src = "https://randomuser.me/api/portraits/men/32.jpg";
                        }}
                      />
                      <BsPlusCircleFill className="plus-icon" />
                    </div>
                    <h3 className="teacher-name mb-3" style={{fontSize : "15px"}}>{teacher.name}</h3>
                    <p className="subject">{subjectName}</p>
                    <div className="card-footer d-flex text-center mx-auto justify-content-center">
                      <div className="info text-center mx-auto ">
                        <span>⭐</span>
                        <span>{teacher.rate || 0} تقييم</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="teacher-card">
                    <div className="teacher-image">
                      <img 
                        src={teacher.prof_img || teacher.image || "https://randomuser.me/api/portraits/men/32.jpg"} 
                        alt={teacher.name} 
                        onError={(e) => {
                          e.target.src = "https://randomuser.me/api/portraits/men/32.jpg";
                        }}
                      />
                      <BsPlusCircleFill className="plus-icon" />
                    </div>
                    <h3 className="teacher-name mb-3" style={{fontSize : "15px"}}>{teacher.name}</h3>
                    <p className="subject">{subjectName}</p>
                    <div className="card-footer justify-content-center">
                      <div className="info">
                        <span>⭐</span>
                        <span>{teacher.rate || 0} تقييم</span>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            ))
          ) : (
            <div className="text-center w-100">
              <p>لا توجد بيانات للمدرسين</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {isAuthenticated && pagination && pagination.pages_count > 1 && (
          <div className="pagination-container mt-4">
            <div className="pagination">
              {Array.from({ length: pagination.pages_count }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubjectTeachers; 